import React, { type ReactNode, useMemo } from "react";
import { NavigationItemsContext } from "helpers/react_context/navigation_items_context";

import AUDIT_LOGS from "navigation/sections/audit_logs";
import DAILY_REVIEW from "navigation/sections/daily_review";
import DASHBOARD from "navigation/sections/dashboard";
import FINANCE from "navigation/sections/finance";
import { FINANCIAL_SERVICES } from "navigation/sections/financial_services";
import GROUP_MANAGEMENT from "navigation/sections/group_management";
import INVENTORY from "navigation/sections/inventory";
import { CAPITAL } from "navigation/sections/lspd_capital";
import MENU_MANAGEMENT from "navigation/sections/menu_management";
import MENUS from "navigation/sections/menus";
import REPORTS from "navigation/sections/reports";
import SETTINGS from "navigation/sections/settings";
import SUPERUSER from "navigation/sections/superuser";
import TRUST from "navigation/sections/trust";
import USERS_ROLES from "navigation/sections/users_roles";
import WORKFORCE from "navigation/sections/workforce";

import type { ISectionProps } from "types/navigation";

/**
 * @deprecated
 * Please use useNavigationItems
 */
export const TEMPORARY_GLOBAL_NAV_ITEMS: {
  current: readonly ISectionProps[];
} = {
  current: [],
};

export interface INavigationItemsProviderProps {
  children?: ReactNode;
}

export const NavigationItemsProvider = ({
  children,
}: INavigationItemsProviderProps) => {
  const navItems = useMemo<ISectionProps[]>(
    () => [
      DASHBOARD,
      REPORTS,
      DAILY_REVIEW,
      MENU_MANAGEMENT,
      GROUP_MANAGEMENT,
      MENUS,
      INVENTORY,
      FINANCE,
      USERS_ROLES,
      WORKFORCE,
      CAPITAL,
      FINANCIAL_SERVICES,
      AUDIT_LOGS,
      SETTINGS,
      TRUST,
      SUPERUSER,
    ],
    []
  );
  TEMPORARY_GLOBAL_NAV_ITEMS.current = navItems;
  return (
    <NavigationItemsContext.Provider value={navItems}>
      {children}
    </NavigationItemsContext.Provider>
  );
};
